import React, { useEffect, useState, useRef, Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import { getData, postData } from '../../Service/ApiMethod'
import { Afterlogin, Beforlogin, RECOMMENDED_CANDIDATES, Recruiter_Create_Message, Selected_Candidate, UNLOCKNOW, vaccancy_url } from '../../Service/service'

import AddToList from './AddToList'
import ApplicantsAvailability from './ApplicantsAvailability'
import MapView from '../home/component/MapView'
import RoundsPopup from '../home/component/RoundsPopup'
import ShareButtons from '../home/component/ShareButtons'
import { useTranslation } from "react-i18next";
import { lang } from '../../lang'


const HireBoxBlackScreen = (props) => {


    const [ln,setLn] = useState('en')
    const [singleCandidateData, setSingleCandidateData] = useState()
    // const [candidate, setCandidate] = useState()
    // const [unlockProfileData, setUnlockProfileData] = useState()
    const [isError, setIsError] = useState()
    const [contactDetails, setContactDetails] = useState(false)
    const [user_ID, setUser_ID] = useState(0)
    // const [vacancyUserID, setVacancyUserID] = useState(0)
    const [vacancy, setVacancy] = useState([])
    const [addtolistPopupp, setAddtolistPopupp] = useState(false)
    const [showFullDetail, setShowFullDetail] = useState(false)
    // const [showButtons, setShowButtons] = useState(false)
    // const [lockdetailsunlock, setLockdetailsunlock] = useState(false)
    // const [vacancyPopup, setVacancyPopup] = useState(true)
    const [roundPopup, setRoundPopup] = useState(false)
    const [candidateMessageData, setCandidateMessageData] = useState()
    const [showSharePopup, setShowSharePopup] = useState(false)

    const navigate = useNavigate()

    const setBlackPopup = props?.setBlackPopupValue
    
    // const setChangeInRound = props?.setChangeInRound

    const hiredata = props?.item

    // const candidateitem = singleCandidateData?.candidate?.map((item, i)=>{
    //     return(
    //          item

    //     )
    // })

    const { t } = useTranslation()

    console.log('candidateitem', hiredata)

    const ref = useRef(null);
    useOutsideAlerter(ref);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setBlackPopup && setBlackPopup(false)
                    // setChangeInRound && setChangeInRound(true)
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    const pdf = singleCandidateData ? singleCandidateData?.seeker_details[0]?.license:''
    console.log('pfffffffffff', pdf)
  

    const pdfUrl = pdf.substring(2, pdf.length - 2);
  
   
    
    // const handleClick = () => {
    
    // window.open(pdfUrl, '_blank');
  
     
    // };
    const getRecommendedCandidateData = () => {
        setSingleCandidateData(props?.item)
        console.log('HireBoxdata', props?.item)
    }

    console.log('HireBxdata', props?.item)

    console.log('hire Candidate Data', singleCandidateData)




    // const loginToken =  localStorage.getItem('catzapp_token');
    // console.log('myData',  loginToken);
    // }
  
    const handleShare = async (id) => {
        let _encodedSeekerId = window.btoa(id)
        console.log(_encodedSeekerId, "encoded seekrr")
        if (navigator?.share) {
            navigator?.share({
                title: `Share title`,
                message: `This is share description.`,
                url: "https://recruiter.catzapp.com/?id="+singleCandidateData?.user
            })
                .then(() => console.log('shared sucessfully'))
                .catch(err => {
                    console.log('error ', err)
                })
        }
  
        // console.log('seekerid', singleCandidateData?.user)
    }
 

    // const handleContactDetails = (userID) => {
    //     setContactDetails(!contactDetails)
    //     setUser_ID(userID)
    //     const objDataSelectedCondidate = {
    //         "seeker_id": userID,
    //         "round_status": "unlocked"
    //     }
    //     if (!contactDetails) {
    //         console.log("applicant id: ", userID)
    //         const selected_candidate = () => {
    //             postData(objDataSelectedCondidate, Selected_Candidate)
    //                 .then(response => response.json())
    //                 .then(data => console.log(data))
    //                 .catch((err) => {
    //                     setIsError(err.message);
    //                     console.log(isError);
    //                 })
    //         }
    //         const handleVacancy = () => {
    //             getData(vaccancy_url)
    //                 .then(res => res.json())
    //                 .then(data => {
    //                     console.log("VacnacyData", data.data)
    //                     setVacancy(data.data)
    //                 })
    //         }
    //         selected_candidate()
    //         handleVacancy()
    //     }
    // }

    // const handleSelectedTitle = (e) => {
    //     setVacancyUserID(e.target.value)
    //     console.log('setVacancy', setVacancyUserID)
    // }


    // const handleOK = () => {
    //     if(vacancyUserID!==undefined && vacancyUserID != 'Select Vacancy'){
    //         const objDataUnlockNow = {
    //             "jobseeker_id": user_ID,
    //             "vacancy": vacancyUserID
    //         }
    //         const postOnUnlockNow = () => {
    //             postData(objDataUnlockNow, UNLOCKNOW)
    //                 .then(response => response.json())
    //                 .then(data => console.log(data))
    //                 .catch((err) => {
    //                     setIsError(err.message);
    //                     console.log(isError);
    //                 })
    //         }
    //         postOnUnlockNow()
    //         console.log("User_ID", user_ID)
    //         console.log("vacancyUserID", vacancyUserID)

    //         setContactDetails(!contactDetails)
    //         setShowButtons(true)
    //     } else{
    //         setContactDetails(false)
    //     }

    // }

    const handleMessage = (id) => {
        const obj = {
            "jobseeker_id": id
        }
        postData(obj, Recruiter_Create_Message)
            .then(res => res.json())
            .then(data => {
                console.log('get message candidate response', data.data)
                setCandidateMessageData(data.data)
                navigate('/message', { state: { data: data.data } })
            })
            .catch((err) => {
                console.log(err.message)
            })
    }

    console.log('candidateMessageData', candidateMessageData)

    // const gotoSelectHire = (item) => {
    //     setBlackPopup(false)
    //     navigate('/hire-details', { state: { item } })
    // }
    // const handleClose = () => {
    //     setBlackPopup(false)
    // }

    useEffect(() => {
        if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
        getRecommendedCandidateData()
    }, [])


    return (
        <>
            {/** <div style={{ position: 'fixed', right: '10%', top: '20%', zIndex: '99999999999', height: '75vh', overflow: 'auto' }}>
          {
            searchData?.map((singleCandidateData, index) => {
              return (
               
              )
            })
          } </div>*/}
            {singleCandidateData &&
                <>
                    <div className="blur-screen-full-area applicants-details-container blackscreen" style={{ }}
                   
                      onClick={(e)=>{
                        e.stopPropagation()
                    }} ref={ref}>
                        <div className="row"   >
                            <div className="col-10 pl-0">
                                <div className="row d-flex">
                                    <div className="map-left px-0 mb-3 flex-center relative">
                                        {/** <img src="./images/msg1.png" className="" alt="" />*/}
                                        <div class="map-profile">
                                        <img src={singleCandidateData?.seeker_details[0]?.image || "../images/Vector.png"} className="" alt="" style={{  borderRadius:"50%" }} />
                                        </div>
                                        <p className="premium">{t('Premium')}</p>
                                    </div>
                                    <div className="map-right">

                                        <p className="candidate-name" style={{  }}>
                                            {singleCandidateData?.seeker_details[0]?.first_name} {singleCandidateData?.seeker_details[0]?.last_name}
                                        </p>


                                        <p className="designation text-bold text-white">
                                            {singleCandidateData?.seeker_details[0]?.profile_title}

                                        </p>


                                    </div>
                                </div>

                                <>
                                    <div className="mb-2" style={{ color: 'white', marginTop: '10px' }}>
                                        <img className="call-imgg" src='../images/call-reciever.png' alt='img' style={{ marginRight: "10px" }} />
                                        {singleCandidateData?.seeker_details[0]?.mobile_number}
                                    </div>
                                    <div style={{ color: 'white',display:'flex',alignItems:'center',wordBreak: 'break-all' }}>
                                        <img className="call-imgg" src='../images/email.png' alt='img' style={{ marginRight: "10px" }} />
                                        {singleCandidateData?.seeker_details[0]?.email}
                                    </div>
                                </>


                                <p className="heading h3 mt-2 text-white">
                                    {singleCandidateData?.seeker_details[0]?.short_description}
                                </p>


                                <p className="sub-heading text-white font-12 mt-2">
                                    {t('About Me')}
                                </p>
                                <p className="text-white text break-para">
                                    {singleCandidateData?.seeker_details[0]?.cover_latter}
                                </p>
                                <p className="sub-heading text-white font-12 mt-2">
                                    {t('Experience')}
                                </p>
                                <p className="text-white text">
                                    {singleCandidateData?.seeker_details[0]?.experience_id} {singleCandidateData?.seeker_details[0]?.experience_id > 1 ? 'Years' : 'Year'} of Experience
                                    {/* {singleCandidateData?.experience[0]?.experience} {singleCandidateData?.experience[0]?.experience>1?'Years':'Year'} of Experience required */}
                                </p>

                                <p className="sub-heading text-white font-12 mt-2">
                                    {t('Type of employment contract')}
                                </p>
                                <p className="text-white text">
                                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.SearchEvents[singleCandidateData?.seeker_details[0]?.employment_type]:""}
                                    {(parseInt(singleCandidateData?.availability)) > 0 &&
                                        <span className="text-warning text-bold">
                                            ({t('Available')} {singleCandidateData?.availability})
                                        </span>
                                    }

                                </p>

                                <p className="sub-heading text-white font-12 mt-2">{t('Expected Salary')}</p>
                                <p className="text-white text" >
                                    {singleCandidateData?.seeker_details[0]?.currency} {singleCandidateData?.seeker_details[0]?.expected_salary} {singleCandidateData?.seeker_details[0]?.compensation_details}
                                </p>

                                {!showFullDetail &&
                                    <button className="jobseeker-btn "
                                        style={{
                                            backgroundColor: 'blue',
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowFullDetail(true)
                                        }}

                                    >
                                        {t('See Full Details')}
                                    </button>
                                }

                            </div>
                            <div className="col-2 px-0">
                                <div className=" flex-column sticky-top">
                                    <div className="white-circle flex-center flex-column">
                                        <p className="font-8">{parseInt(singleCandidateData?.percentage_match)}%</p>
                                        <p className="font-8">{t('Match')}</p>
                                    </div>
                                    <div className="white-circle flex-center" onClick={(e) => {
                                        e.stopPropagation()
                                        setRoundPopup(true)
                                    }}>
                                        <img src="../images/bookmark.png" alt="" />
                                    </div>
                                    <div className="white-circle flex-center" onClick={() => setAddtolistPopupp(true)} >
                                        <img className='send-job' src="../images/send-job.png" alt="" style={{ cursor: "pointer" }}/>
                                    </div>
                                    {addtolistPopupp && <AddToList setAddtolistPopupp={setAddtolistPopupp} seekerID={singleCandidateData?.seeker_id} />}

                                    <div className="white-circle flex-center" onClick={(e)=>{
                                    e.stopPropagation() 
                                    handleShare(singleCandidateData?.seeker_id
                                     )
                                    // setShowSharePopup(!showSharePopup)

                                }}>
                                    <img src="../images/share-icon.png" alt="" />
                                </div>
                                {showSharePopup && 
                                <div style={{position:'fixed', width:'70px', marginLeft:'-10px', height:'40px', background:'white', display:'flex', justifyContent:'center', alignContent:'center', padding:'3px'}}>
                                    <ShareButtons url={`https://jobportalrecruiter.atwpl.com/${singleCandidateData?.seeker_id}`} /> 
                                </div>
                                }
                                    <div className="white-circle flex-center" onClick={(e) => {
                                        e.stopPropagation()
                                        handleMessage(singleCandidateData?.seeker_id)
                                        // navigate('/message')
                                    }} >
                                        <img className='msg-icon' src="../images/messages.png" alt="" />
                                    </div>



                                    {/*                                 
                                    <>
                                     <div
                                    className="red-circle flex-center"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleClose()
                                    }}
                                >
                                    <img src="./images/cross.png" alt="" />
                                </div>
                                <div className="yellow-circle flex-center flex-column" onClick={(e) => {
                                    e.stopPropagation()
                                    gotoSelectHire(singleCandidateData)
                                }}>
                                    <p className="font-12">Hire</p>
                                </div>
                                </>
                                */}

                                </div>
                            </div>
                        </div>
                        <div className="applicants-distance">
                            <p className="distance-text">
                                <img
                                    src="../images/location.png"
                                    className=" img-size16"
                                    alt=""
                                />
                                {parseInt(singleCandidateData?.distance)} {t('KM Away')}
                            </p>
                        </div>
                        {showFullDetail &&
                            <div>
                                <div style={{ marginTop: "-20px", marginBottom: "10px" }}>
                                    <p className="sub-heading text-white font-12 mt-2">{t('Skills')}</p>
                                    {singleCandidateData?.skill_set?.map((skill, i) => {
                                        return (
                                            <div className=" " key={i} style={{ display: "inline-block", marginBottom: '5px' }} >
                                                <span className="transparent-border-btn">
                                                    {skill?.skill_name}</span>
                                            </div>
                                        )
                                    })}
                                    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Education')}
                                    </p>

                                    <div className=" " style={{ display: "inline-block" }} >
                                       
                    <span className="transparent-border-btn">
                                            {singleCandidateData?.highest_education_det}
                   </span>
                                    </div>

                                    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Passout Year')}
                                    </p>
                                   
                                  
                                    <p className="text-white text" >
                                    {singleCandidateData?.seeker_details[0]?.passout_year}
                            </p>
                               
                            {
    singleCandidateData?.license != [] ? (<> 
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Licenses')}
                                    </p>
                                    {
                                       singleCandidateData?.license.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = singleCandidateData?.license[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  {t('Licenses')} {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
    </>):null
}               

        {
    singleCandidateData?.certificate != [] ? (<>
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('certificate')}
                                    </p>
                                    {
                                       singleCandidateData?.certificate.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = singleCandidateData?.certificate[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  {t('certificate')} {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
                                   
    </>):null
}  

                                    {/* <p className="sub-heading text-white font-12 mt-2">
                                        {t('Licenses')}
                                    </p> */}
                                    <div>
                                        {/* <span className="transparent-border-btn"
                                        onClick={handleClick}>
                                            {t('Licenses')}
                                        </span> */}
                                        {/* <span className="transparent-border-btn">
                                            License Name 2
                                        </span> */}
                                    </div>
                                </div>
                                <div style={{  }}>
                                    <ApplicantsAvailability unlockedUserData={singleCandidateData} />
                                </div>
                                <div style={{  marginTop: '-9px', marginBottom: '-10px' }}>
                                    <MapView mapHeight='400px' userLocation={singleCandidateData} />
                                </div>
                            </div>
                        }
                        {roundPopup &&
                    <RoundsPopup 
                    seekerID={singleCandidateData?.seeker_id} 
                    setRoundPopup={setRoundPopup}  />
                }
                    </div>
                </>
            }
        </>
    )
}

export default HireBoxBlackScreen